import { LanguageReadiness } from "@curriculum-studio/core";
import { HttpClient, HttpClientRequest, HttpClientResponse } from "@effect/platform";
import { Data, Effect, Schema } from "effect";
import { runtime } from "./runtime.ts";

// The client for `GET /api/language-packs/languages`: every language studio knows, and whether its
// pack can carry a run — what the New Curriculum modal offers and the Language packs page annotates.

export class LanguageReadinessRequestFailed extends Data.TaggedError(
  "LanguageReadinessRequestFailed",
)<{
  readonly status: number;
}> {}

const LanguageReadinessList = Schema.Array(LanguageReadiness);

export const listLanguageReadiness = Effect.gen(function* () {
  const client = yield* HttpClient.HttpClient;
  const response = yield* client.execute(HttpClientRequest.get("/api/language-packs/languages"));
  if (response.status >= 400)
    return yield* Effect.fail(new LanguageReadinessRequestFailed({ status: response.status }));
  return yield* HttpClientResponse.schemaBodyJson(LanguageReadinessList)(response);
}).pipe(Effect.scoped);

export const languageReadinessActions = {
  // A failure is an empty list: readiness only decides what is offered, and offering nothing is the
  // safe reading of "could not tell".
  languages: (): Promise<readonly LanguageReadiness[]> =>
    runtime.runPromise(listLanguageReadiness.pipe(Effect.catchAll(() => Effect.succeed([])))),
};
